import { render, staticRenderFns } from "./business-client.vue?vue&type=template&id=2a9014ab"
import script from "./business-client.vue?vue&type=script&lang=js"
export * from "./business-client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports